module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "tittle"
  }, [_c('p', {
    staticClass: "spanflex"
  }, [_c('span', {
    class: _vm.span1_show == 1 ? 'red' : 'nored',
    staticStyle: {
      "margin-left": "30px",
      "display": "inline-block",
      "height": "30px",
      "cursor": "pointer",
      "position": "relative"
    },
    on: {
      "click": function($event) {
        return _vm.clickspan1()
      }
    }
  }, [_vm._v("\n        基本信息 "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.span1_show == 1),
      expression: "span1_show ==1"
    }],
    staticClass: "redspan"
  })]), _vm._v(" "), _c('span', {
    class: _vm.span1_show == 2 ? 'red' : 'nored',
    staticStyle: {
      "margin-left": "200px",
      "display": "inline-block",
      "height": "30px",
      "cursor": "pointer",
      "position": "relative"
    },
    on: {
      "click": function($event) {
        return _vm.zxgsKzxx()
      }
    }
  }, [_vm._v("\n        扩展信息 "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.span1_show == 2),
      expression: "span1_show ==2"
    }],
    staticClass: "redspan"
  })]), _vm._v(" "), _c('span', {
    class: _vm.span1_show == 3 ? 'red' : 'nored',
    staticStyle: {
      "margin-left": "200px",
      "display": "inline-block",
      "height": "30px",
      "cursor": "pointer",
      "position": "relative"
    },
    on: {
      "click": function($event) {
        return _vm.zxgsDpzy()
      }
    }
  }, [_vm._v("\n        店铺主页 "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.span1_show == 3),
      expression: "span1_show ==3"
    }],
    staticClass: "redspan"
  })])])]), _vm._v(" "), _c('extend', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.span1_show == 2),
      expression: "span1_show ==2"
    }],
    ref: "extend",
    attrs: {
      "isadd": _vm.isadd
    },
    on: {
      "changespanshow": _vm.changespanshow,
      "isaddfun": _vm.isaddfun
    }
  }), _vm._v(" "), _c('homepagezxgs', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.span1_show == 3),
      expression: "span1_show ==3"
    }],
    ref: "homepagezxgs",
    on: {
      "changespanshow": _vm.changespanshow
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3a526a41!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/staging/compant.vue
// module id = 1679
// module chunks = 3